module.exports = __webpack_public_path__ + "static/media/LoadingSpinnerLogo.1eaddfa9.svg";